import { withTheme } from '@mui/styles';
import styled from 'styled-components';

export default withTheme(styled.div`
  .MuiAppBar-root {
    height: 50px;
    background: ${(props: any) => props.theme.palette.primary.dark};
    color: white;
    font-size: 18px;
    display: flex;
  }

  .header-container {
    display: flex;
    height: 50px;

    align-items: center;
    .logo {
      height: 30px;
      width: 80px;
    }
    .contact-box {
      display: flex;
      align-items: center;
    }
    svg {
      font-size: 18px;
      margin-right: 10px;
    }
    a {
      margin-left: 25px;
      color: white;
      text-decoration: unset;
    }
    .join-button {
      width: 130px;
      height: 30px;
      border-radius: 28px;
      color: white;
      border: solid 1px white;
      line-height: 1;
      background-color: ${(props: any) => props.theme.palette.primary.dark};
    }
  }
`);
